export const WEB3FORMS_ENDPOINT = 'https://api.web3forms.com/submit';
export const WEB3FORMS_ACCESS_KEY = 'b06f5550-6c3c-4ecd-9a81-5d6de22dbb59';
